import React, { useCallback, useState, useEffect } from "react";
import {
  ResellerHeaders,
  ResellerHeaders1,
} from "../../../../utility/TableHeaders";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomTable from "../../../components/main_comps/custom_table";
import MainComponent from "../../../components/ui_comps/MainComponent";
import { BiEditAlt } from "react-icons/bi";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { fecthResellerList } from "../../../../services/fetchListingData";
import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import CustomModal from "../../../components/main_comps/custom_modal";
import AlertModals from "../../../components/ui_comps/AlertModals";
import { useSnackbar } from "notistack";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import {
  ACTIVATE,
  ACTIVE,
  ADMIN,
  ADMIN_USER,
  DEACTIVATE,
  RESELLER_ADD_ACL,
  RESELLER_FILTER_ACL,
  RESELLER_VIEWMORE_ACL,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import CommissionModal from "../../../components/ui_comps/CommissionModal";
import CustomTabs from "../../../components/main_comps/custom_tabs";
import { tabs } from "../clients";
import moment from "moment";
import { AiOutlinePlus } from "react-icons/ai";
import { colorDarkBlue } from "../../../../utility/constants/colorManager";
import { resellerModalNavigation } from "../../../../data/redux/slice/modalNavigationSlice";
import { removeResellerData } from "../../../../data/redux/slice/resellerDataSlice";
import ResellerOnboardIndex from "./reseller_onboard";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../services/secureStorage";
import { setHeaders } from "../../../../services/aclValidateServiceTable";

export const ActionComponent = ({ onClick }) => {
  return (
    <div style={{ display: "flex" }}>
      <CustomButton
        styles={{
          backgroundColor: "#38369C",
          border: "1px solid #38369C",
          marginLeft: "10px",
        }}
        title="Download Report"
        textStyles={{ color: "white" }}
        onClick={onClick}
      />
    </div>
  );
};
function ResellerIndex() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const resellerData = useSelector((state) => state.listingSlice.resellerList);
  const [openToggleModal, setOpenToggleModal] = useState(false);
  const [resellerDataRow, setResellerDataRow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openCommissionModal, setOpenCommissionModal] = useState(false);
  const filters = useSelector((state) => state.globalFiltersSlice);
  const [onClickAddReseller, setOnClickAddReseller] = useState(false);
  const [role, setRole] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const currentModalStep = useSelector((state) => state.modalNavSlice);
  const aclData = useSelector((state) => state.aclSlice.aclList);

  const onClickChangeStatus = (status, userId) => {
    setLoading(true);
    ApiRequestPost.updateReseller({
      status,
      userId,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(
            `Reseller ${status ? "Activated" : "De-Activated"} Successfully`,
            {
              variant: "success",
            }
          );
          dispatch(
            fecthResellerList({
              dateRange:
                filters?.fromDate && filters?.toDate
                  ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(filters?.toDate).format("DD/MM/YYYY")
                  : "",
              page: 0,
              size: 10,
              status: filters?.status?.value
                ? filters?.status?.value === "ACTIVE"
                  ? true
                  : false
                : "",
              userId: filters?.resellerId?.value ?? "",
            })
          );
          setOpenToggleModal(false);
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    dispatch(
      fecthResellerList({
        dateRange: "",
        page: 0,
        size: 10,
        userId: "",
        status: "",
      })
    );
  }, []);

  const getData = async () => {
    const role = await secureStorage.getItem(SS_ROLE);
    setRole(role?.toUpperCase());
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: ["dateRange", "status", "resellerName"],
            })
          );
        }}
        headerTitle="Reseller"
        onClickFilterCall={(data) => {
          dispatch(
            fecthResellerList({
              dateRange:
                data?.fromDate && data?.toDate
                  ? moment(data?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(data?.toDate).format("DD/MM/YYYY")
                  : "",
              page: 0,
              size: 10,
              userId: data?.resellerId?.value,
              status: data?.status?.value
                ? data?.status?.value === "ACTIVE"
                  ? true
                  : false
                : "",
            })
          );
        }}
        customButtonRequired={
          aclData.includes(RESELLER_ADD_ACL) ? (
            <CustomButton
              title={"Add Reseller"}
              styles={{
                backgroundColor: colorDarkBlue,
                border: "none",
                marginLeft: 10,
              }}
              onClick={() => {
                setOnClickAddReseller(true);
              }}
              icon={<AiOutlinePlus color="white" />}
            ></CustomButton>
          ) : null
        }
      />

      <div style={{ padding: "0px 10px", overflow: "hidden" }}>
        <CustomTable
          currentPage={resellerData?.currentPageNo - 1}
          data={resellerData?.resellers}
          headers={setHeaders(ResellerHeaders, aclData)}
          totalElements={resellerData?.totalRecords}
          totalPages={resellerData?.totalPages}
          handlePaginate={(page) => {
            dispatch(
              fecthResellerList({
                dateRange:
                  filters?.fromDate && filters?.toDate
                    ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(filters?.toDate).format("DD/MM/YYYY")
                    : "",
                page: page + 1,
                size: 10,
                userId: filters?.resellerId?.value ?? "",
                status: filters?.status?.value
                  ? filters?.status?.value === "ACTIVE"
                    ? true
                    : false
                  : "",
              })
            );
          }}
          onViewMore={(data) => {
            if (aclData.includes(RESELLER_VIEWMORE_ACL)) {
              navigate("/reseller/details", {
                state: {
                  data,
                },
              });
            }
          }}
          onStatusChange={(val) => {
            setOpenToggleModal(true);
            setResellerDataRow(val);
          }}
          onViewMoreCommission={(val) => {
            setOpenCommissionModal(true);
            setResellerDataRow(val);
          }}
        />
      </div>

      {onClickAddReseller && (
        <CustomModal
          headerTitle="Onboard Reseller"
          open={onClickAddReseller}
          onClose={() => {
            setOnClickAddReseller(false);
            dispatch(resellerModalNavigation(1));
            dispatch(removeResellerData({}));
          }}
          containerStyle={styles.modalContainerStyle}
          isBackRequired={currentModalStep?.resellerStep > 1 ? true : false}
          onClickBack={() => {
            if (currentModalStep?.resellerStep > 1) {
              dispatch(
                resellerModalNavigation(currentModalStep?.resellerStep - 1)
              );
            }
          }}
          isConfirmationModalRequired={true}
        >
          <ResellerOnboardIndex
            onSuccess={() => {
              setOnClickAddReseller(false);
              dispatch(resellerModalNavigation(1));
              dispatch(removeResellerData({}));
              dispatch(
                fecthResellerList({
                  dateRange: "",
                  page: 0,
                  size: 10,
                  userId: "",
                  status: "",
                })
              );
            }}
            onClose={() => {
              setOnClickAddReseller(false);
            }}
          />
        </CustomModal>
      )}
      {openToggleModal && (
        <CustomModal
          headerTitle=""
          open={openToggleModal}
          onClose={() => {
            setOpenToggleModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <AlertModals
            confirmButtonTitle={"Yes"}
            onClickCancel={() => setOpenToggleModal(false)}
            onClickOk={(reason) => {
              if (reason) {
                onClickChangeStatus(
                  resellerDataRow?.isEnabled ? false : true,

                  resellerDataRow?.userId
                );
              } else {
                enqueueSnackbar(
                  `Please enter reason for ${
                    resellerDataRow?.isEnabled ? "Deactivate" : "Activate"
                  }`,
                  {
                    variant: "error",
                  }
                );
              }
            }}
            loading={loading}
            role="Reseller"
            action={resellerDataRow?.isEnabled ? "Deactivate" : "Activate"}
            reason={resellerDataRow?.isEnabled ? "Deactivating" : "Activating"}
            isConditional={false}
          />
        </CustomModal>
      )}

      {openCommissionModal && (
        <CustomModal
          headerTitle="Slab Commission"
          open={openCommissionModal}
          onClose={() => {
            setOpenCommissionModal(false);
          }}
          containerStyle={{
            minWidth: 300,
            maxWidth: 400,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <CommissionModal data={resellerDataRow} />
        </CustomModal>
      )}
    </div>
  );
}
const styles = {
  modalContainerStyle: {
    minWidth: 350,
    maxWidth: 450,
    height: "auto",
    maxHeight: 800,
  },
};

export default ResellerIndex;
